import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class DocAdicionalService {

  constructor(private apollo: Apollo) { }


  addDocumento(){
    return gql`
      mutation createDocumentosAdicional($input: createDocumentosAdicionalInput!) {
      createDocumentosAdicional(input: $input) {
        documentosAdicional {
          id
          nombreArchivo
          
          cliente {
            id
          }
          
          
        }
      }
    }
    `;
  }

  deleteDocumentoById(){
    return gql`
      mutation deleteDocumentosAdicional($input: deleteDocumentosAdicionalInput!) {
        deleteDocumentosAdicional(input: $input) {
          documentosAdicional {
            id
          }
        }
      }
    `;
  }

  updateDocumentoById(){
    return gql`
      mutation updateDocumentosAdicional($input: updateDocumentosAdicionalInput!) {
        updateDocumentosAdicional(input: $input) {
          documentosAdicional {
            id 
            tipo
            idPadre
          }
        }
      }
    `;
  }

  getDocumentosByCentro(){
    return gql`
      query getDocumentosAdicionalByCentro($id: ID!){
        centro(id: $id){
          id
          documentos_adicionals(sort: "createdAt:desc") {
            id
            nombreArchivo
            periocidad
            tipo
            fechaCaducidad
            fechaValidez
            numArchivo
            validado
            enFecha
            caducado
            proximoCaduca
            createdAt
            nombre
            estado
            idPadre
            noCaduca
            firstTime
            fechaCheck
            cliente{
              id
            }
            contratista{
              id
            }
            centros{
              id
            }
            
          }
        }
      }
    `;
  }

  getAllDocumentosSinValidar() {
    return gql`
      query getAllDocumentosAdicionalSinValidar {
        documentosAdicionals(
          where: {
            validado: "false"
          },
          sort: "comentariosNuevos:desc"
        )
        {
          id
          nombre
          tipo
          nombreArchivo
          subidoPor
          contratista {
            nombreComercial
          }
          
          centros {
            nombre
          }
          comentariosNuevos
          comentarios {
            comentario
            fecha
            causa
          }
          createdAt
          fechaCaducidad
        }
      }
    `;
  }

  getAllDocumentos() {
    return gql`
      query getAllDocumentosAdicionalSinValidar {
        documentosAdicionals(
          sort: "comentariosNuevos:desc"
        )
        {
          id
          nombre
          tipo
          nombreArchivo
          subidoPor
          numArchivo
          contratista {
            nombreComercial
          }
          
          centros {
            nombre
          }
          comentariosNuevos
          comentarios {
            comentario
            fecha
            causa
          }
          createdAt
          fechaCaducidad
        }
      }
    `;
  }

  getDocumentoById(){
    return gql`
      query getDocumentoAdicionalById($id: ID!) {
        documentosAdicional(id: $id) {
          id
          nombre
          fechaValidez
          fechaCaducidad
          validado
          caducado
          nombreArchivo
          proximoCaduca
          enFecha
          tipo
          url
          noCaduca
          subidoPor
          createdAt
          periocidad
          numArchivo
          createdAt
          contratista {
            id
            nombreComercial
            
          }
          cliente{
            id
          }
          centros{
            nombre
            id
            comentariosAdic1 {
              comentario
              fecha
              causa
            }
            comentariosAdic2 {
              comentario
              fecha
              causa
            }
            comentariosAdic3 {
              comentario
              fecha
              causa
            }
            
          }
  
          comentariosNuevos
          comentarios {
            comentario
            fecha
            causa
          }
        }
      }
    `;
  }

  setComentariosLeidos(id: string){
    return this.apollo.mutate({
      mutation: this.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "comentariosNuevos": false
          }
        }   
      }
    })
  }

}
